import { render, staticRenderFns } from "./CourseFormDialog.vue?vue&type=template&id=3e87d672&scoped=true"
import script from "./CourseFormDialog.vue?vue&type=script&lang=js"
export * from "./CourseFormDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseFormDialog.vue?vue&type=style&index=0&id=3e87d672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e87d672",
  null
  
)

export default component.exports